import axios from 'axios'; // 引入axios
import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据，后面会提到
import Vue from 'vue'
import router from '../router'
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Message.install = function (Vue, options) {
  Vue.prototype.$message = Message
}
Vue.use(Message)

// 环境的切换

if (process.env.NODE_ENV == 'development') {
	// axios.defaults.baseURL = 'http://jy.dunwang.com';
	axios.defaults.baseURL = 'http://res.joy366.com/';
} else if (process.env.NODE_ENV == 'debug') {
	axios.defaults.baseURL = 'http://jy.dunwang.com';
} else if (process.env.NODE_ENV == 'production') {
	axios.defaults.baseURL = 'http://res.joy366.com/';
}
//设置请求超时
axios.defaults.timeout = 10000;
//post请求头的设置
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 响应拦截器
axios.interceptors.response.use(
response => {
	// 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
	// 否则的话抛出错误
	if (response.status === 200) {
		return Promise.resolve(response);
	} else {
		return Promise.reject(response);
	}
},
// 服务器状态码不是2开头的的情况
// 这里可以跟你们的后台开发人员协商好统一的错误状态码    
// 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
// 下面列举几个常见的操作，其他需求可自行扩展
error => {
	if (error.response.status) {
		this.$message({
			duration: 1500,
			message: error.response.data.msg,
			type: 'error'
		});
		return Promise.reject(error.response);
	}
});
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
			params: params
		}).then(res => {
			if (res.data.code ==0) {
				if (res.data.data.type) {
					if (res.data.data.type == "no_login") {
						console.log(url,new Date());
						this.$message({
							duration: 2000,
							message: res.data.msg,
							type: 'error'
						});
						setTimeout(() => {
							localStorage.removeItem("token");
							if (this.$route.path == "/") {
								location.reload();
							} else {
								this.$router.push({ path: "/" });
							}
						}, 2000);
					}
				} else {
					if (['测试账号不可用','测试账号已过期','非学生无权操作','非教师无权操作'].indexOf(res.data.msg) > 0) {
						this.$message({
							duration: 2000,
							message: res.data.msg,
							type: 'error'
						});
						setTimeout(() => {
							if (window.history.length <= 1) {
								this.$router.push({ path: "/" });
							} else {
								this.$router.go(-1);
							}
						}, 1000);
					} else if (res.data.msg == "免费观看次数已用完" || res.data.msg == "权限不足，请先升级会员") {
						this.$message({
							duration: 2000,
							message: res.data.msg,
							type: 'error'
						});
						setTimeout(() => {
							this.$router.push({ path: "/vip_code" });
						}, 2000);
					} else {
						this.$message({
							duration: 2000,
							message: res.data.msg,
							type: 'error'
						});
					}
				}
				return false
			}
			resolve(res.data);
		}).catch(err => {
			reject(err.data)
		})
	});
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
	return new Promise((resolve, reject) => {
		axios.post(url, QS.stringify(params))
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}
